document.addEventListener('click', (e) => {
  const openBtn = e.target.closest('[data-cvd-size-open]');
  if (openBtn) {
    const dialog = document.getElementById(openBtn.dataset.cvdSizeOpen);
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    return;
  }

  const closeBtn = e.target.closest('[data-cvd-size-close]');
  if (closeBtn) {
    closeBtn.closest('dialog')?.close();
    return;
  }

  // clique fora da caixa (no fundo escuro) fecha
  if (e.target.matches('dialog.cvd-size-dialog')) e.target.close();
});